<template>
  <div class="pt-4 sm:pt-0 pr-8 pl-10 sm:px-8">
    <div class="flex flex-row items-center gap-3 mb-3">
      <button
        @click="setActiveSubMenu('ListKapal')"
        class="flex flex-row justify-center items-center w-4 h-4 bg-gray-400 rounded-md"
        title="Kembali ke menu tool">
        <i class="material-icons text-lg text-white">chevron_left</i>
      </button>
      <h1 class="flex flex-col">
        <span class="text-sm text-white mr-1 font-bold">Filter List Kapal</span>
      </h1>
    </div>
    <div class="flex flex-col mb-1">
      <label class="mb-2 text-xs text-white">Status Transmitter</label>
      <select
        v-model="activeFilter.index"
        class="form-input px-3 w-full h-8 rounded-md text-xs">
        <option
          v-for="(item, index) in filter"
          :key="index"
          :value="index">{{ item.title }}</option>
      </select>
    </div>
    <div class="w-full mb-3">
      <label class="text-xs text-white">Nama Perusahaan</label>
      <input
        v-model="optionalFilter.nama_perusahaan"
        class="w-full h-8 rounded-md text-sm text-gray-500"
        type="text">
    </div>
    <div class="flex flex-col mb-3">
      <label class="mb-2 text-xs text-white">Jenis Alat Tangkap</label>
      <select
        v-model="optionalFilter.jenis_alat_tangkap"
        class="form-input px-3 w-full h-8 rounded-md text-xs">
        <option value="Bouke Ami">Bouke Ami</option>
        <option value="Purse Seine (Pukat Cincin) Pelagis Besar Dengan Satu Kapal">Purse Seine (Pukat Cincin) Pelagis Besar Dengan Satu Kapal</option>
        <option value="Kapal Pengangkut Ikan Segar/Beku ke Negara Tujuan">Kapal Pengangkut Ikan Segar/Beku ke Negara Tujuan</option>
        <option value="Pancing Ulur (Hand Line) Tuna">Pancing Ulur (Hand Line) Tuna</option>
        <option value="Kapal Pengangkut Ikan Hidup dari Tempat Pembudidayaan / Pelabuhan Check Point ke Negara Tujuan Ekspor">Kapal Pengangkut Ikan Hidup dari Tempat Pembudidayaan / Pelabuhan Check Point ke Negara Tujuan Ekspor</option>
        <option value="Jala Jatuh Berkapal">Jala Jatuh Berkapal</option>
        <option value="Kapal Pengangkut Ikan antar Pelabuhan Pangkalan">Kapal Pengangkut Ikan antar Pelabuhan Pangkalan</option>
        <option value="Jaring Insang Tetap">Jaring Insang Tetap</option>
        <option value="Pukat Labuh">Pukat Labuh</option>
        <option value="Purse Seine (Pukat Cincin) Pelagis Kecil Dengan Satu Kapal">Purse Seine (Pukat Cincin) Pelagis Kecil Dengan Satu Kapal</option>
        <option value="Pukat Cincin Pelagis Kecil dengan Satu Kapal">Pukat Cincin Pelagis Kecil dengan Satu Kapal</option>
        <option value="Huhate (Pole and Line)">Huhate (Pole and Line)</option>
        <option value="Kapal Pengangkut Ikan Hidup Antar Tempat Pembudidayaan Ikan">Kapal Pengangkut Ikan Hidup Antar Tempat Pembudidayaan Ikan</option>
        <option value="Jaring Tarik Berkantong (Freezer)">Jaring Tarik Berkantong (Freezer)</option>
        <option value="Pancing Ulur (Hand Line)">Pancing Ulur (Hand Line)</option>
        <option value="Rawai Tuna">Rawai Tuna</option>
        <option value="Jaring Hela Udang Berkantong">Jaring Hela Udang Berkantong</option>
        <option value="Jaring Liong Bun">Jaring Liong Bun</option>
        <option value="Jaring Insang Hanyut">Jaring Insang Hanyut</option>
        <option value="Pancing Ulur">Pancing Ulur</option>
        <option value="Pengangkut/Pengumpul">Pengangkut/Pengumpul</option>
        <option value="Rawai Dasar (Set Long Line)">Rawai Dasar (Set Long Line)</option>
        <option value="Huhate">Huhate</option>
        <option value="Pukat Labuh (Long Bag Set Net)">Pukat Labuh (Long Bag Set Net)</option>
        <option value="Jaring Tarik Berkantong (Es Batu)">Jaring Tarik Berkantong (Es Batu)</option>
        <option value="Kapal Pengangkut Ikan Sewa untuk Ikan Hidup dari Check Point ke Negara Tujuan (Berbendera Asing)">Kapal Pengangkut Ikan Sewa untuk Ikan Hidup dari Check Point ke Negara Tujuan (Berbendera Asing)</option>
        <option value="Pancing Cumi">Pancing Cumi</option>
        <option value="Jaring Insang Oseanik">Jaring Insang Oseanik</option>
        <option value="Pukat Cincin Pelagis Besar dengan Satu Kapal">Pukat Cincin Pelagis Besar dengan Satu Kapal</option>
        <option value="Pancing Cumi (Squid Jigging)">Pancing Cumi (Squid Jigging)</option>
        <option value="Kapal Pengangkut Ikan di Laut Lepas">Kapal Pengangkut Ikan di Laut Lepas</option>
        <option value="Kapal Pengangkut Ikan dari Daerah Penangkapan Ikan (WPPNRI)">Kapal Pengangkut Ikan dari Daerah Penangkapan Ikan (WPPNRI)</option>
        <option value="Rawai Hanyut (Drifting Long Lines) / Rawai Tuna">Rawai Hanyut (Drifting Long Lines) / Rawai Tuna</option>
        <option value="Pancing Ulur Tuna">Pancing Ulur Tuna</option>
        <option value="Bagan Berperahu">Bagan Berperahu</option>
        <option value="Jaring Hela Ikan Berkantong">Jaring Hela Ikan Berkantong</option>
        <option value="Bubu (Pots)">Bubu (Pots)</option>
        <option value="Pancing Cumi Mekanis">Pancing Cumi Mekanis</option>
        <option value="Jala Jatuh Berkapal (Cast Nets)">Jala Jatuh Berkapal (Cast Nets)</option>
        <option value="Rawai Dasar">Rawai Dasar</option>
      </select>
    </div>
    <div class="flex flex-row gap-1 justify-end">
      <button
        @click="download()"
        class="bg-green-500 px-2 py-2 rounded-md text-xs text-white"
        type="button">Export List Kapal</button>
      <button
        @click="apply()"
        class="bg-blue-500 px-2 py-2 rounded-md text-xs text-white"
        type="button">Apply</button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'

export default {
  name: 'FilterListKapal',
  computed: {
    ...mapGetters([
      'filter',
      'activeFilter',
      'optionalFilter',
      'auth'
    ])
  },
  methods: {
    ...mapActions(['toChangeActiveFilter']),
    ...mapMutations(['setActiveSubMenu']),
    download: async function () {
      let exportUrl = `${window.config.BASEURL}/libs/report/list-kapal.html?`

      exportUrl += `token=${this.auth.token}`
      exportUrl += `&filter=${this.activeFilter.id}`

      window.open(
        exportUrl,
        { target: '__blank' }
      )
    },
    apply: async function () {
      this.toChangeActiveFilter(this.activeFilter.index)
    }
  }
}
</script>
